import Image from "next/image";
import { useState } from "react";
import ExpandableBox from "@/components/faqs/ExpandableBox";
import { faqItems } from "./utils";

const FaqMainPage = (): JSX.Element => {
  const [activeIndex, setActiveIndex] = useState(-1);
  const [isOpened, setSelectOpened] = useState(false);

  const clickHandler = (idx: number) => {
    setActiveIndex((current) => (current === idx ? -1 : idx));
  };
  const onClick = () => {
    setSelectOpened(!isOpened);
  };

  return (
    <div className="relative px-5 mt-10 xl:mb-6 xl:mt-20">
      <div className="relative text-left xl:text-center md:mb-14">
        <div className="absolute hidden transform rotate-180 -left-10 -top-5 w-96 h-36 xl:inline-block">
          <Image
            src="/shared/shapes.svg"
            alt="shapes doodles"
            objectFit="contain"
            layout="fill"
            priority
          />
        </div>

        <h1 className="xl:w-1/2 mx-auto mb-10 font-bold text-4xl xs:text-[44px] md:text-[56px] xl:text-[76px] xs:leading-[46px] md:leading-[59px] xl:leading-[80px]">
          Frequently Asked Questions
        </h1>
        <h2 className="font-serif text-xl md:text-2xl lg:text-3xl xl:w-1/2 mb-10 mx-auto">
          Discover how Keyzy&apos;s rent-to-buy solution can help you get onto the property ladder
          sooner.
        </h2>

        <div className="absolute hidden -right-10 -top-5 w-96 h-36 xl:inline-block">
          <Image
            src="/shared/shapes.svg"
            alt="shapes doodles 2"
            objectFit="contain"
            layout="fill"
            priority
          />
        </div>
      </div>
      <div className="flex relative flex-col md:px-6 lg:px-11 xl:px-20">
        <div className="flex flex-col w-full lg:w-4/5 mx-auto">
          <div id="1" className="xl:pt-2">
            <h2 className="mb-5 text-xl font-bold md:mt-5">Terminology</h2>
            <div className="relative z-30 w-full">
              {faqItems
                .filter(function (obj) {
                  return obj.category === "Terminology";
                })
                .sort((a, b) => a.index - b.index)
                .map((faq) => (
                  <div key={faq.index}>
                    <ExpandableBox
                      question={faq.question}
                      answer={faq.answer}
                      active={activeIndex === faq.index}
                      clickHandler={() => clickHandler(faq.index)}
                    />
                    {faq.index === faqItems.length - 1 && (
                      <div className="hidden w-1 bg-white h-11 md:inline-block xl:hidden"></div>
                    )}
                  </div>
                ))}
            </div>
            <div></div>
          </div>
        </div>

        <div className="flex flex-col w-full lg:w-4/5 mx-auto">
          <div id="2" className="xl:pt-2">
            <h2 className="mb-5 text-xl font-bold md:mt-5">
              Common Questions About Keyzy&apos;s Rent-to-Buy Solution
            </h2>
            <div className="relative z-30 w-full">
              {faqItems
                .filter(function (obj) {
                  return obj.category === "Frequenty asked questions about Keyzy";
                })
                .sort((a, b) => a.index - b.index)
                .map((faq) => (
                  <div key={faq.index}>
                    <ExpandableBox
                      question={faq.question}
                      answer={faq.answer}
                      active={activeIndex === faq.index}
                      clickHandler={() => clickHandler(faq.index)}
                    />
                    {faq.index === faqItems.length - 1 && (
                      <div className="hidden w-1 bg-white h-11 md:inline-block xl:hidden"></div>
                    )}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqMainPage;
